import React, { useState } from "react";
import { NullaryFn } from "@tvg/ts-types/Functional";
import {
  Button,
  Modal,
  Icon,
  Header,
  IconNames,
  useTheme
} from "@tvg/design-system";
import {
  List,
  StyledButton,
  ListItem,
  ButtonContainer
} from "./styled-components";

export interface ListViewFilterProps {
  onChange: (value: string) => void;
  button: {
    text: string;
    icon: IconNames;
    qaLabel: string;
    iconPosition?: "start" | "end";
    isActive?: boolean;
  };
  qaLabel?: string;
  filterOptions: Array<{ label: string; value: string; isActive: boolean }>;
  modalTitle: string;
  onClickLeftButton?: NullaryFn<void>;
  leftButtonText?: string;
}

const ListViewFilter = ({
  onChange,
  button,
  filterOptions,
  modalTitle,
  onClickLeftButton,
  leftButtonText
}: ListViewFilterProps) => {
  const { colors } = useTheme();
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <ButtonContainer colors={colors} isActive={button.isActive}>
        <Button
          size="m"
          variant="tertiary"
          qaLabel={button.qaLabel || "list-view-filter"}
          onPress={() => setOpen(!isOpen)}
          icon={button.icon}
          iconPosition={button.iconPosition}
        >
          {button.text}
        </Button>
      </ButtonContainer>
      <Modal
        isOpen={isOpen}
        title={modalTitle}
        type="flexible"
        onClose={() => setOpen(false)}
        p={0}
        headerLeftElement={
          filterOptions.findIndex(({ isActive }) => isActive) !== -1 &&
          leftButtonText &&
          typeof onClickLeftButton === "function" ? (
            <Button
              onPress={() => {
                onClickLeftButton();
                setOpen(false);
              }}
              qaLabel="list-view-filter-left-button"
              variant="tertiary"
              size="m"
            >
              {leftButtonText}
            </Button>
          ) : undefined
        }
      >
        <List>
          {filterOptions.map(({ value, label, isActive }) => (
            <ListItem key={value}>
              <StyledButton
                colors={colors}
                isActive={isActive}
                onClick={() => {
                  setOpen(false);
                  onChange(value);
                }}
              >
                <Header
                  tag="h3"
                  color={isActive ? "blue_accent.500" : "grey.900"}
                >
                  {label}
                </Header>
                {isActive && (
                  <Icon name="tick" size="m" lineColor="blue_accent.500" />
                )}
              </StyledButton>
            </ListItem>
          ))}
        </List>
      </Modal>
    </>
  );
};

export default ListViewFilter;
